import type { SortType } from "@/features/catalog/stores/catalogStore";

/**
 * upstreamのselectSortMethodは日付操作をトグルとして扱うため、PC版selectで
 * 古順を直接選んだ場合だけ必要な回数だけ日付操作を適用する。
 */
export function selectDesktopSort(
  currentSort: SortType,
  selectedSort: SortType,
  selectSortMethod: (sort: SortType) => void,
): void {
  if (selectedSort === currentSort) return;

  if (selectedSort === "old") {
    if (currentSort !== "new") selectSortMethod("new");
    selectSortMethod("new");
    return;
  }

  selectSortMethod(selectedSort);
}
